/*
 * @Author: mayanxia 
 * @Date: 2020-11-18 16:05:13 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2023-01-13 09:51:05
 */
<template>
    <a-modal
        :width="modalWidth"
        :visible="visible"
        :title="title"
        destroyOnClose
        :confirmLoading="confirmLoading"
        @ok="handleSubmit"
        @cancel="handleCancel"
        :cancelText="$t('关闭')"
        wrapClassName="ant-modal-cust-warp"
        >
            <div class="form-contain">
                <a-divider orientation="left">{{ $t('基本数据') }}
                    <span>
                        ({{ $t('表类型') }}: {{model.mtCodeName}})
                    </span>
                </a-divider>
            <a-form-model ref="taskModal" :model="taskModel" :rules="taskRules" :colon="false" layout="vertical">
                <a-row :gutter="24">
                    <a-col :span="12" v-if="model.batchType === 1">
                        <a-form-model-item :label="$t('所选区域')">
                            <a-input-search
                                style="width: 90%"
                                :placeholder="$t('点击选择区域')"
                                v-model="checkedAreaNameString"
                                readOnly
                                @search="onSearchArea">
                                <a-button slot="enterButton" icon="search">{{ $t('选择') }}</a-button>
                            </a-input-search>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12" v-if="model.batchType === 2">
                        <a-form-model-item :label="$t('所选表号')">
                            <a-textarea readOnly v-model="model.meterIdList" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12" v-if="model.batchType === 3">
                        <a-form-model-item :label="$t('导入文件')">
                            <a-upload name="file"
                                :multiple="false"
                                accept=".xls"
                                :fileList="fileList"
                                :headers="tokenHeader"
                                :beforeUpload="beforeUpload"
                                :remove="handleRemove"
                                >
                                <a-button>
                                    <a-icon type="upload" />
                                    {{ $t('选择导入文件') }}
                                </a-button>
                            </a-upload>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item :label="$t('任务名称')" prop="taskName">
                            <a-input :placeholder="$t('请输入任务名称')" v-model="taskModel.taskName"></a-input>
                        </a-form-model-item>
                    </a-col>
                    <a-col :xl="24" :lg="24" :md="24" :sm="24">
                        <a-form-model-item :label="$t('描述')" prop="remark">
                            <a-textarea v-model="taskModel.remark" rows="2" :placeholder="$t('请输入备注')" style="width:100%"/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
            <a-row :gutter="8" style="margin-top: 20px">
                <a-col :span="10">
                    {{ $t('选择命令') }}
                    <a-select v-model="commandKey" style="width: 100%" @change="handleCommandChange" :placeholder="$t('选择命令')">
                        <a-select-option v-for="item in commandList" :key="item.key" :value="item.key" :label="$t(item.title)">
                            {{ $t(item.title) }}
                        </a-select-option>
                    </a-select>
                </a-col>
            </a-row>
            <a-form-model 
                v-if="commandKey == 3"
                ref="formModel"
                :model="formModel"
                :rules="rules"
                :colon="false"
            >
                <a-row :gutter="8">
                    <a-col :span="8">
                        <a-form-model-item :label="$t('开始时间')" prop="startDate">
                            <!--<a-input v-model="formModel.startDate"/>-->
                            <a-date-picker v-model="formModel.startDate" style="width: 100%" format="YYYY-MM-DD" :placeholder="$t('请输入日期')" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-model-item :label="$t('记录条数')" prop="recordNum">
                            <a-input-number :min='1' :max="30" v-model="formModel.recordNum"/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
            <a-form-model 
                v-else-if="[4,5,6].includes(commandKey)"
                ref="formModel"
                :model="formModel"
                :rules="rules"
                :colon="false"
            >
                <a-row :gutter="8">
                    <a-col :span="8">
                        <a-form-model-item :label="$t('起始条数')" prop="startNo">
                            <a-input-number :min='1' :max="50" v-model="formModel.startNo"/>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-model-item :label="$t('记录条数')" prop="recordNum">
                            <a-input-number :min='1' :max="30" v-model="formModel.recordNum"/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
            <a-form-model 
                v-else-if="commandKey === 13"
                ref="formModel"
                :model="formModel"
                :rules="rules"
                :colon="false"
            >
                <a-row :gutter="8">
                    <a-col :span="8">
                        <a-form-model-item :label="$t('运行秘钥')" prop="enKey">
                            <a-input v-model="formModel.enKey"/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
            <a-form-model 
                v-else-if="commandKey === 14"
                ref="formModel"
                :model="formModel"
                :rules="rules"
                :colon="false"
            >
                <a-row :gutter="8">
                    <a-col :span="8">
                        <a-form-model-item :label="$t('根秘钥')" prop="rootKey">
                            <a-input v-model="formModel.rootKey"/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
            <template v-else-if="commandKey === 0">
                <a-row  :gutter="24" style="margin-top: 20px;height: 30vh">
                    <a-col :span="6" style="height: 100%;overflow-y: scroll;overflow-x: hidden;">
                        <a-row :gutter="0">
                            <a-checkbox-group @change="changeSetParams">
                                <a-col :span="24" style="padding: 6px" v-for="item in setParamsList" :key="item.key">
                                    <a-checkbox  :value="item.key" >
                                        {{ $t(item.title) }}
                                    </a-checkbox>
                                </a-col>
                            </a-checkbox-group>
                        </a-row>
                        
                    </a-col>
                    <a-col :span="18" style="height: 100%;overflow-y: scroll;overflow-x: hidden;">
                        <a-form-model 
                            ref="formModel"
                            :model="formModel"
                            :rules="rules"
                            :colon="false"
                        >
                            <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(0)">
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('过流告警阀值')" prop="overflowAlarmTop" class="ant-input-number-affix">
                                        <a-input-number v-model="formModel.overflowAlarmTop"/>
                                        <div class="ant-input-number-suffix">L/h</div>
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('持续过流告警时间')" prop="overflowContinueTime" class="ant-input-number-affix">
                                        <a-input-number v-model="formModel.overflowContinueTime"/>
                                        <div class="ant-input-number-suffix">{{ $t('分钟') }}</div>
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('反流告警阀值')" prop="reverseOverflowAlarmTop" class="ant-input-number-affix">
                                        <a-input-number v-model="formModel.reverseOverflowAlarmTop"/>
                                        <div class="ant-input-number-suffix">L/h</div>
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('持续反流告警时间')" prop="reverseOverflowContinueTime" class="ant-input-number-affix">
                                        <a-input-number v-model="formModel.reverseOverflowContinueTime"/>
                                        <div class="ant-input-number-suffix">{{ $t('分钟') }}</div>
                                    </a-form-model-item>
                                </a-col>
                                
                            </a-row>
                            <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(2)">
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('即时告警ID')" prop="currentAlarmId">
                                        <a-input-number v-model="formModel.currentAlarmId"/>
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(1)">
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('IP地址')" prop="netIp">
                                        <a-input v-model="formModel.netIp"/>
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('端口号')" prop="netPort">
                                        <a-input-number v-model="formModel.netPort" :min="0" :max="65535" :precision="0" />
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(3)">
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('APN参数')" prop="apn">
                                        <a-input v-model="formModel.apn"/>
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(9)">
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('上报离散起始时间')" prop="spreadStartTime" class="form-item-series">
                                        <a-select class="series-first-select" v-model="formModel.spreadStartTimeDay" style="width: 30%;">
                                            <a-select-option v-for="item in 28" :key="item" :value="item">{{item}}</a-select-option>
                                        </a-select>
                                        <a-time-picker 
                                            format="HH:mm"
                                            v-model="formModel.spreadStartTime"  />
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('上报离散结束时间')" prop="spreadEndTime" class="form-item-series">
                                        <a-select class="series-first-select" v-model="formModel.spreadEndTimeDay" style="width: 30%;">
                                            <a-select-option v-for="item in 28" :key="item" :value="item">{{item}}</a-select-option>
                                        </a-select>
                                        <a-time-picker 
                                            format="HH:mm"
                                            v-model="formModel.spreadEndTime"  />
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('上报离散结束估长')" prop="spreadTime">
                                    <a-input-number :min="10" :max="255" :precision="0" v-model="formModel.spreadTime"/>
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="16">
                                    <a-form-model-item :label="$t('上报频率')" prop="upRate" class="form-item-series">
                                        <a-input-number :min="1" :max="formModel.upRateUnit == 10? 60: formModel.upRateUnit == 20? 24: formModel.upRateUnit == 30? 30: formModel.upRateUnit == 40?4: 1"
                                          v-model="formModel.upRate" style="width: 50%;border-top-right-radius: 0;border-top-right--radius: 0;" />
                                        <a-select v-model="formModel.upRateUnit" style="width: 30%;">
                                            <a-select-option :value="10">{{ $t('分') }}</a-select-option>
                                            <a-select-option :value="20">{{ $t('时') }}</a-select-option>
                                            <a-select-option :value="30">{{ $t('天') }}</a-select-option>
                                            <a-select-option :value="40">{{ $t('周') }}</a-select-option>
                                            <a-select-option :value="50">{{ $t('月') }}</a-select-option>
                                        </a-select>
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('重传次数')" prop="reportResetTimes">
                                        <a-input-number :min="0" :max="6" :precision="0"
                                            v-model="formModel.reportResetTimes" placeholder="0~6" />
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('重传间隔')" prop="reportResetInterval" class="ant-input-number-affix">
                                        <a-input-number :min="0" :max="65535" :precision="0"
                                            v-model="formModel.reportResetInterval" placeholder="0~65535" />
                                            <div class="ant-input-number-suffix">{{ $t('秒') }}</div>
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('失联次数阈值')" prop="reportConcatFailTimes">
                                        <a-input-number :min="0" :max="255" :precision="0"
                                            v-model="formModel.reportConcatFailTimes" :placeholder="$t('0~255,255表示不启用')" />
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('激活上报次数')" prop="reportActiveTimes">
                                        <a-input-number :min="0" :max="255" :precision="0"
                                            v-model="formModel.reportActiveTimes" :placeholder="$t('0~255,255表示不启用')" />
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('高频上报功能')" prop="highUpStatus">
                                        
                                        <a-select v-model="highUpStatus">
                                            <a-select-option :value="0">{{ $t('请选择') }}</a-select-option>
                                            <a-select-option :value="1">{{ $t('开启') }}</a-select-option>
                                            <a-select-option :value="2">{{ $t('关闭') }}</a-select-option>
                                        </a-select>
                                    </a-form-model-item>
                                </a-col>
                                <template v-if="highUpStatus == 1">
                                    <a-col :span="16">
                                        <a-form-model-item :label="$t('高频上报周期')" prop="highUpRate" class="form-item-series">
                                            <a-input-number :min="formModel.highUpRateUnit == 10? 10: 1" :max="formModel.highUpRateUnit == 10? 60: formModel.highUpRateUnit == 20? 24:1"
                                                v-model="formModel.highUpRate" style="width: 50%;border-top-right-radius: 0;border-top-right--radius: 0;" />
                                            <a-select v-model="formModel.highUpRateUnit" style="width: 30%;">
                                                <a-select-option :value="10">{{ $t('分') }}</a-select-option>
                                                <a-select-option :value="20">{{ $t('时') }}</a-select-option>
                                            </a-select>
                                        </a-form-model-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-model-item :label="$t('高频上报次数')" prop="highUpTimes">
                                            <a-input-number :min="0" :max="255" :precision="0"
                                                v-model="formModel.highUpTimes" placeholder="0~255" />
                                        </a-form-model-item>
                                    </a-col>
                                </template>
                            </a-row>
                            <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(10)">
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('电压告警阈值1')" prop="batteryValue1" class="ant-input-number-affix">
                                        <a-input-number :min="0" :precision="2" v-model="formModel.batteryValue1"/>
                                        <div class="ant-input-number-suffix">V</div>
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('电压告警阈值2')" prop="batteryValue2" class="ant-input-number-affix">
                                        <a-input-number :min="0" :precision="2" v-model="formModel.batteryValue2"/>
                                        <div class="ant-input-number-suffix">V</div>
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(11)">
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('是否启用密集采样')">
                                        <a-switch v-model="isStartCollect" :checked-children="$t('开启')" :un-checked-children="$t('关闭')" />
                                    </a-form-model-item>
                                </a-col>
                                <template v-if="isStartCollect">
                                    <a-col :span="8">
                                        <a-form-model-item :label="$t('密集采样起始时间')" prop="collectStartTime">
                                            <a-time-picker v-model="formModel.collectStartTime" :default-open-value="moment('000000', 'HH:mm:ss')" format="HH:mm:ss" />
                                        </a-form-model-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-model-item :label="$t('密集采样结束时间')" prop="collectEndTime">
                                            <a-time-picker v-model="formModel.collectEndTime" :default-open-value="moment('000000', 'HH:mm:ss')" format="HH:mm:ss" />
                                        </a-form-model-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-model-item :label="$t('密集采样时间间隔')" prop="collectTime"  class="ant-input-number-affix">
                                            <a-input-number :min="0" :max="30" :precision="0"
                                                v-model="formModel.collectTime" placeholder="0~30" />
                                            <div class="ant-input-number-suffix">{{ $t('分钟') }}</div>
                                        </a-form-model-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-model-item :label="$t('密集采样天数')" prop="collectDay">
                                            <a-input-number :min="1" :max="7" :precision="0"
                                                v-model="formModel.collectDay" placeholder="1~7" />
                                        </a-form-model-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-model-item :label="$t('密集采样格式')" prop="collectModel">
                                            <a-select v-model="formModel.collectModel">
                                                <a-select-option value="00">
                                                    00
                                                </a-select-option>
                                                <a-select-option value="01">
                                                    01
                                                </a-select-option>
                                            </a-select>
                                        </a-form-model-item>
                                    </a-col>
                                </template>
                            </a-row>
                            <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(12)">
                                <a-form-model-item :label="$t('是否启用间隔流量采集')">
                                    <a-switch v-model="isStartReportRate" :checked-children="$t('开启')" :un-checked-children="$t('关闭')" />
                                </a-form-model-item>
                                <template v-if="isStartReportRate">
                                    <a-col :span="8">
                                        <a-form-model-item :label="$t('间隔流量采集间隔')" prop="reportRateInterval" class="ant-input-number-affix">
                                            <a-input-number v-model="formModel.reportRateInterval" :min="10" :max="255" :precision="0" placeholder="10~255" />
                                            <div class="ant-input-number-suffix">{{ $t('分钟') }}</div>
                                        </a-form-model-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-model-item :label="$t('间隔流量数据指示')" prop="rateIntervalModel">
                                            <a-select v-model="formModel.rateIntervalModel">
                                                <a-select-option value="00">00</a-select-option>
                                                <a-select-option value="01">01</a-select-option>
                                                <!--
                                                <a-select-option value="02">02</a-select-option>
                                                <a-select-option value="03">03</a-select-option>
                                                <a-select-option value="04">04</a-select-option>
                                                <a-select-option value="05">05</a-select-option>
                                                -->
                                            </a-select>
                                        </a-form-model-item>
                                    </a-col>
                                </template>
                            </a-row>
                            <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(13)">
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('阀门配置')" prop="hasFksatus">
                                        <a-select v-model="formModel.hasFksatus">
                                            <a-select-option value="00">{{ $t('无阀') }}</a-select-option>
                                            <a-select-option value="01">{{ $t('阀门堵转功能不开启') }}</a-select-option>
                                            <a-select-option value="03">{{ $t('阀门堵转功能开启') }}</a-select-option>
                                        </a-select>
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="8" v-if="formModel.hasFksatus == '01'">
                                    <!--<a-form-model-item label="阀门使能" prop="fkStatus">
                                        <a-input v-model="formModel.fkStatus"/>
                                    </a-form-model-item>
                                    -->
                                    <a-form-model-item :label="$t('阀门到位超时时间')" prop="valveCtrlTimeOut" class="ant-input-number-affix">
                                        <a-input-number v-model="formModel.valveCtrlTimeOut" :min="0" :precision="0" placeholder="" />
                                        <div class="ant-input-number-suffix">{{ $t('秒') }}</div>
                                    </a-form-model-item>
                                    <a-form-model-item :label="$t('阀门维护')" prop="fkStatus">
                                        <a-select v-model="formModel.fkStatus">
                                            <a-select-option value="00">{{ $t('不起用') }}</a-select-option>
                                            <a-select-option value="01">{{ $t('启用') }}</a-select-option>
                                        </a-select>
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(14)">
                                <a-col :span="24">
                                    <a-col :span="8">
                                        <a-form-model-item :label="$t('缺电是否关阀')">
                                            <a-switch v-model="isStartElecCloseFk" :checked-children="$t('是')" :un-checked-children="$t('否')" />
                                        </a-form-model-item>
                                    </a-col>
                                    <a-col :span="8" v-if="isStartElecCloseFk">
                                        <a-form-model-item :label="$t('缺电关阀时间')" prop="elecTime" class="ant-input-number-affix">
                                            <a-input-number v-model="formModel.elecTime" :min="0" :precision="0" placeholder="" />
                                            <div class="ant-input-number-suffix">{{ $t('分钟') }}</div>
                                        </a-form-model-item>
                                    </a-col>
                                </a-col>
                                <a-col :span="24">
                                    <a-col :span="8">
                                        <a-form-model-item :label="$t('干扰是否关阀')">
                                            <a-switch v-model="isStartGrCloseFk" :checked-children="$t('是')" :un-checked-children="$t('否')" />
                                        </a-form-model-item>
                                    </a-col>
                                    <a-col :span="8" v-if="isStartGrCloseFk">
                                        <a-form-model-item :label="$t('干扰关阀时间')" prop="workGfTime" class="ant-input-number-affix">
                                            <a-input-number v-model="formModel.workGfTime" :min="0" :precision="0" placeholder="" />
                                            <div class="ant-input-number-suffix">{{ $t('分钟') }}</div>
                                        </a-form-model-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-model-item :label="$t('干扰持续时间')" prop="workGrTime" class="ant-input-number-affix">
                                            <a-input-number v-model="formModel.workGrTime" :min="0" :precision="0" placeholder="" />
                                            <div class="ant-input-number-suffix">{{ $t('分钟') }}</div>
                                        </a-form-model-item>
                                    </a-col>
                                </a-col>
                            </a-row>
                            <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(15)">
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('NB加密使能')" prop="hasEncry">
                                        <a-select v-model="formModel.hasEncry">
                                            <a-select-option :value="1">{{ $t('加密') }}</a-select-option>
                                            <a-select-option :value="0">{{ $t('不加密') }}</a-select-option>
                                        </a-select>
                                    </a-form-model-item>
                                </a-col>
                                <!--
                                <a-col :span="8" v-if="formModel.hasEncry == 1">
                                    <a-form-model-item label="秘钥" prop="sn">
                                        <a-input v-model="formModel.sn" placeholder="" />
                                    </a-form-model-item>
                                </a-col>
                                -->
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('红外加密使能')" prop="hasRedEncry">
                                        <a-select v-model="formModel.hasRedEncry">
                                            <a-select-option :value="1">{{ $t('加密') }}</a-select-option>
                                            <a-select-option :value="0">{{ $t('不加密') }}</a-select-option>
                                        </a-select>
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(16)">
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('上线指令内容设置')" prop="directContent">
                                        <a-input v-model="formModel.directContent" placeholder="" />
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(17)">
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('日结数据组数')" prop="dayRecordNum">
                                        <a-input-number v-model="formModel.dayRecordNum" :min="0" :max="31" :precision="0" placeholder="" />
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('日结数据指示')" prop="dayRecordIndex">
                                        <a-select v-model="formModel.dayRecordIndex">
                                            <a-select-option :title="$t(item.title)" v-for="item in dayRecordIndexList" :key="item.key" :value="item.key" :label="$t(item.title)">
                                                {{ $t(item.title) }}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(18)">
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('表类型切换')" prop="meterType">
                                        <a-select v-model="formModel.meterType">
                                            <a-select-option :value="0">{{ $t('平台计费水表') }}</a-select-option>
                                            <a-select-option :value="1">{{ $t('表端计费水量表') }}</a-select-option>
                                            <a-select-option :value="2">{{ $t('表端计费金额表') }}</a-select-option>
                                        </a-select>
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(19)">
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('试用量')" prop="tryNum">
                                        <a-input-number v-model="formModel.tryNum" :placeholder="$t('0-255,255表示不启用')" />
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(20)">
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('单价')" prop="price">
                                        <a-input-number v-model="formModel.price" placeholder="0-65535" />
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(21)">
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('剩余金额')" prop="remainyMoney">
                                        <a-input-number v-model="formModel.remainyMoney" placeholder="" />
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(22)">
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('工作模式')" prop="workType">
                                        <a-select v-model="formModel.workType">
                                            <a-select-option :value="0">{{ $t('调试模式') }}</a-select-option>
                                            <a-select-option :value="1">{{ $t('用户模式') }}</a-select-option>
                                            <a-select-option :value="2">{{ $t('试用模式') }}</a-select-option>
                                        </a-select>
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(23)">
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('最大补包次数')" prop="packNum">
                                        <a-input-number v-model="formModel.packNum" :min="0" :max="30" placeholder="0~30" />
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(24)">
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('采样间隔')" prop="pressCollectTime">
                                        <a-input-number v-model="formModel.pressCollectTime" :min="5" :max="65535" placeholder="5~65535" />
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('采样始起始时间')" prop="pressCollectStartTime">
                                        <a-date-picker v-model="formModel.pressCollectStartTime" show-time />
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('采样时长')" prop="pressCollectRecordNum">
                                        <a-input v-model="formModel.pressCollectRecordNum" placeholder="" />
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('压力数据指示')" prop="pressCollectIndex">
                                        <a-input v-model="formModel.pressCollectIndex" placeholder="" />
                                    </a-form-model-item>
                                </a-col>
                                 <a-col :span="8">
                                    <a-form-model-item :label="$t('压力报警灵敏度')" prop="pressAlarmRate">
                                        <a-input-number v-model="formModel.pressAlarmRate" :min="2" :max="6" placeholder="2~6" />
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('压力报警上限')" prop="pressAlarmTop" class="ant-input-number-affix">
                                        <a-input-number v-model="formModel.pressAlarmTop" :min="0" :placeholder="$t('压力报警上限')" />
                                        <div class="ant-input-number-suffix">MPa</div>
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('压力报警下限')" prop="pressAlarmLow" class="ant-input-number-affix">
                                        <a-input-number v-model="formModel.pressAlarmLow" :min="0" :placeholder="$t('压力报警下限')" />
                                        <div class="ant-input-number-suffix">MPa</div>
                                    </a-form-model-item>
                                </a-col>
                                <!--
                                <a-col :span="8">
                                    <a-form-model-item label="压力值" prop="pressValue">
                                        <a-input v-model="formModel.pressValue" placeholder="" />
                                    </a-form-model-item>
                                </a-col>
                                -->
                            </a-row>
                            <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(25)">
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('采样间隔')" prop="tempCollectTime">
                                        <a-input-number v-model="formModel.tempCollectTime" :min="5" :max="65535" placeholder="5~65535" />
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('采样始起始时间')" prop="tempCollectStartTime">
                                        <a-date-picker v-model="formModel.tempCollectStartTime" show-time />
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('采样组数')" prop="tempCollectRecordNum">
                                        <a-input v-model="formModel.tempCollectRecordNum" placeholder="" />
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('温度数据指示')" prop="pressCollectIndex">
                                        <a-input v-model="formModel.tempCollectIndex" placeholder="" />
                                    </a-form-model-item>
                                </a-col>
                                 <a-col :span="8">
                                    <a-form-model-item :label="$t('温度报警灵敏度')" prop="tempAlarmRate">
                                        <a-input-number v-model="formModel.tempAlarmRate" :min="2" :max="6" placeholder="2~6" />
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('温度报警上限')" prop="tempAlarmTop" class="ant-input-number-affix">
                                        <a-input-number v-model="formModel.tempAlarmTop" :min="0" :placeholder="$t('温度报警上限')" />
                                        <div class="ant-input-number-suffix">{{ $t('℃') }}</div>
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('温度报警下限')" prop="tempAlarmLow" class="ant-input-number-affix">
                                        <a-input-number v-model="formModel.tempAlarmLow" :min="0" :placeholder="$t('温度报警上限')" />
                                        <div class="ant-input-number-suffix">{{ $t('℃') }}</div>
                                    </a-form-model-item>
                                </a-col>
                                <!--
                                <a-col :span="8">
                                    <a-form-model-item label="温度值" prop="tempValue">
                                        <a-input v-model="formModel.tempValue" placeholder="" />
                                    </a-form-model-item>
                                </a-col>
                                -->
                            </a-row>
                            <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(4)">
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('校时方式')" prop="checkTimeWay">
                                        <a-select v-model="formModel.checkTimeWay">
                                            <a-select-option :value="undefined" :label="$t('请选择')">
                                                {{ $t('请选择') }}
                                            </a-select-option>
                                            <a-select-option :value="0">{{ $t('不启用') }}</a-select-option>
                                            <a-select-option :value="1">{{ $t('AT指令校时') }}</a-select-option>
                                            <a-select-option :value="2">{{ $t('运营平台校时') }}</a-select-option>
                                        </a-select>
                                    </a-form-model-item>
                                </a-col>
                                <!--v-if="formModel.checkTimeWay == 1"-->
                                <a-col :span="8" >
                                    <a-form-model-item :label="$t('校时')" prop="checkTime">
                                        <a-date-picker v-model="formModel.checkTime" showTime style="width: 100%" format="YYYY-MM-DD HH:mm:ss" :placeholder="$t('请输入日期')" />
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(5)">
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('故障清除位')" prop="cleanFault">
                                        <a-select v-model="formModel.cleanFault" style="width: 100%">
                                            <a-select-option v-for="item in faultList" :key="item.key" :value="item.key" :label="$t(item.title)">
                                                {{ $t(item.title) }}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <!--  设置表底数和脉冲系数命令begin -->
                            <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(6)">
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('表底数')" prop="firstValue" class="ant-input-number-affix">
                                        <a-input-number :suffix="$t('元')" v-model="formModel.firstValue" :min="0" :precision="2"  :placeholder="$t('请输入表底数')" />
                                        <div class="ant-input-number-suffix">m³</div>
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('脉冲系数')" prop="wareParam">
                                        <a-select v-model="formModel.wareParam" style="width: 100%">
                                            <a-select-option :value="undefined" :label="$t('请选择')">
                                                {{ $t('请选择') }}
                                            </a-select-option>
                                            <a-select-option v-for="item in wareParamList" :key="item.key" :value="item.key" :label="$t(item.title)">
                                                {{ $t(item.title) }}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <!--  设置表底数和脉冲系数命令end -->
                            <!--  写表号命令begin -->
                            <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(7)">
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('新表编号')" prop="newMeterId">
                                        <a-input v-model="formModel.newMeterId"/>
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <!--  写表号命令end -->
                            <!--  开关阀命令begin -->
                            <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(8)">
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('开关阀')" prop="fkStatus">
                                        <a-select v-model="formModel.fkStatus" style="width: 100%">
                                            <a-select-option v-for="item in fkStatusList" :key="item.key" :value="item.key" :label="$t(item.title)">
                                                {{ $t(item.title) }}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                        
                            <!--  开关阀命令end -->
                            <!--  报警参数配置命令begin -->
                            <a-row :gutter="16" style="border-bottom: 1px solid #e8e8e8" v-if="setCommandParamsKey.includes(26)">
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('预付费阀门功能')" prop="freightFk">
                                        <a-select v-model="formModel.freightFk">
                                            <a-select-option :value="0">{{ $t('报警不关阀、透支不关阀') }}</a-select-option>
                                            <a-select-option :value="1">{{ $t('报警关阀、透支不关阀') }}</a-select-option>
                                            <a-select-option :value="2">{{ $t('报警不关阀、透支关阀') }}</a-select-option>
                                            <a-select-option :value="3">{{ $t('报警关阀、透支关阀') }}</a-select-option>
                                        </a-select>
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('报警金额')" prop="freightAlarmMoney" class="ant-input-number-affix">
                                        <a-input-number :precision="2" v-model="formModel.freightAlarmMoney" :min="0" :placeholder="$t('请输入报警金额')" />
                                        <div class="ant-input-number-suffix">{{ $t('元') }}</div>
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-model-item :label="$t('透支金额')" prop="freightOverMoney" class="ant-input-number-affix">
                                        <a-input-number :precision="2" v-model="formModel.freightOverMoney" :min="0" :placeholder="$t('请输入透支金额')" />
                                        <div class="ant-input-number-suffix">{{ $t('元') }}</div>
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <!--  报警参数配置命令end -->
                        </a-form-model>
                    </a-col>
                </a-row>
            </template>
            <a-form-model 
                v-else
                ref="formModel"
                :model="formModel"
                :rules="rules"
                :colon="false"
            >
            </a-form-model>
        </div>
        <area-window ref="areaWindow" @ok="modalAreaFormOk" :checkStrictly="true"></area-window>
    </a-modal>
</template>
<script>
import i18n from '@/i18n'
import { postAction,getAction } from '@/api/manage'
import {isNull,isUndefined,isUndefinedAndNull} from '@/utils/validate'
import {paramsToFormData} from '@/utils/util'
import {queryAreaTreeList} from '@/api/api';
import moment from 'moment'
import { USER_AUTH} from "@/store/mutation-types"
import DetailList from '@/components/tools/DetailList'
import { ACCESS_TOKEN } from "@/store/mutation-types"
import Vue from 'vue'
// 引入搜索区域弹出框的组件
import areaWindow from '@/views/system/modules/areaWindow'
const DetailListItem = DetailList.Item
const originalCommandList = [
        {key: 0, title: i18n.t('终端参数设置')},
        {key: 1, title: i18n.t('查询终端参数')},
        {key: 2, title: i18n.t('查询基础信息')},
        {key: 10,title: i18n.t('查询实时数据')},
        {key: 3, title: i18n.t('历史日结信息查询')},
        {key: 4, title: i18n.t('阀门动作记录查询')},
        {key: 5, title: i18n.t('联网失败记录')},
        {key: 6, title: i18n.t('终端故障记录')},
        {key: 7, title: i18n.t('开阀(强制)')},
        {key: 8, title: i18n.t('关阀(强制)')},
        {key: 9, title: i18n.t('取消阀控')},
        {key: 11, title: i18n.t('关阀')},
        {key: 12, title:i18n.t('开阀')},
        {key: 13, title: i18n.t('修改运行秘钥')},
        {key: 14, title: i18n.t('修改根秘钥')}
    ]
const setParamsList = [
        {key: 0, title: i18n.t('设置过流告警信息')},
        {key: 1, title: i18n.t('设置服务器地址')},
        {key: 2, title: i18n.t('即时告警')},
        //{key: 3, title: '设置APN参数'},
        {key: 9, title: i18n.t('设置上报参数')},
        {key: 10, title: i18n.t('设置电压告警阈值')},
        {key: 11, title: i18n.t('密集采样参数')},
        {key: 12, title: i18n.t('间隔流量参数')},
        {key: 13, title: i18n.t('阀门参数配置')},
        {key: 14, title: i18n.t('故障参数配置')},
        {key: 15, title: i18n.t('加密参数')},
        //{key: 16, title: '上线帧设置'},
        {key: 17, title: i18n.t('日结数据指示')},
        //{key: 18, title: '表类型切换'},
        {key: 19, title: i18n.t('试用量')},
        //{key: 20, title: '单价'},
        //{key: 21, title: '剩余金额'},
        //{key: 22, title: '工作模式设置'},
        //{key: 23, title: '补包次数阈值'},
        {key: 24, title: i18n.t('压力参数设置')},
        {key: 25, title: i18n.t('温度参数设置')},
        {key: 4, title: i18n.t('校时')},
        {key: 5, title: i18n.t('故障清除')},
        {key: 6, title: i18n.t('设置表底数和脉冲系数')},
        {key: 7, title: i18n.t('写表号')},
        //{key: 8, title: '开关阀'},
        {key: 26, title: i18n.t('报警参数配置')},
    ]
const faultList = [
        {key: 0, title: i18n.t('不清除故障')},
        {key: 1, title: i18n.t('清除故障')},
        {key: 2, title: i18n.t('清除外接EEPROM内的数据')},
        {key: 3, title: i18n.t('清除表端数据')},
    ]
const fkStatusList = [
        {key: 0, title: i18n.t('关阀')},
        {key: 1, title: i18n.t('开阀')},
        {key: 2, title: i18n.t('取消阀控')}
    ]
const wareParamList = [
        {key: 0, title: '1L'},
        {key: 1, title: '10L'},
        {key: 2, title: '100L'},
        {key: 3, title: '1000L'}
    ]
const dayRecordIndexList = [
        {key: 0, title: i18n.t('日结累计流量两字节')},
        {key: 1, title: i18n.t('日结累计流量四字节')},
        {key: 16, title: i18n.t('日结累计正流量和日结累计负流量两字节')},
        {key: 17, title: i18n.t('日结累计正流量和日结累计负流量四字节')},
        {key: 32, title: i18n.t('日用量两字节')},
        {key: 33, title: i18n.t('日用量四字节')}
]
export default {
    name: "debugNewCommandModal",
    components: {
        DetailList,
        DetailListItem,
        areaWindow
    },
    data () {
        return {
            title:this.$t("命令下发"),
            originalCommandList,
            commandList: [],
            setParamsList,
            faultList,
            fkStatusList,
            wareParamList,
            dayRecordIndexList,
            modalWidth:900,
            visible: false,
            formModel: {
                hasEncry: 1,
                reportResetTimes: 3,
                spreadTime: 60,
                reportResetInterval: 20,
                batteryValue1: 3.1,
                batteryValue2: 2.8,
                collectTime: 5,
                collectDay: 1,
                collectModel: '00',
                reportRateInterval: 30,
                rateIntervalModel: '00',
                wareParam: 2,
                directContent: 23,
                dayRecordNum: 7,
                dayRecordIndex: 0,
                tryNum: 255,
                packNum: 0,
                pressAlarmRate: 3,
                pressAlarmTop: 1.2,
                pressAlarmLow: 1.0,
                upRate: 1,
                upRateUnit: 30,
                checkTimeWay: undefined,
                spreadStartTimeDay: 1,
                spreadEndTimeDay: 1,
                highUpRateUnit: 20,
                highUpRate: 1,
                highUpTimes: 0
            },
            confirmLoading: false,
            model: {},
            commandKey: undefined,
            setCommandParamsKey: [],
            url: {
                sendCommand: '/model/partCommand/sendCommand'
            },
            isStartCollect: true,//是否开启密集采样
            isStartReportRate: true,//是否启用间隔流量采集
            isStartElecCloseFk: true,// 缺电是否关阀
            isStartGrCloseFk: true,// 干扰是否关阀
            highUpStatus: 0, // 高频上报是否开启
            checkedAreaKeys:[],
            halfCheckedAreaKeys: [],
            checkedAreaNameString:"",
            treeData: [],
            checkedAreaNames: [],
            tokenHeader: {'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)},
            fileList: [],
            taskModel: {taskName: ''},
        }
    },
    computed: {
        // i18n：校验规则使用 computed 以响应语言切换
        rules () {
            return {
                startDate: [{ required: true, message: this.$t('请选择日期!') }],
                recordNum: [{ required: true, message: this.$t('请输入查询条数!') }],
                startNo: [{ required: true, message: this.$t('请输入起始条数!') }],
                netIp: [{
                    required: false,
                    pattern: /^((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}$/,
                    message: this.$t('IP输入有误')
                    }],
                netPort: [{
                    required: false,
                    pattern: /^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/,
                    message: this.$t('端口号输入有误')
                }],
                enKey: [
                    {required: true,len:16,message: this.$t('请输入正确的运行秘钥!')}
                ],
                rootKey: [
                    {required: true,len:16,message: this.$t('请输入正确的根秘钥!')}
                ],
                highUpRate: [
                    {required: true,message: this.$t('请输入正确的高频上报周期!')}
                ],
                highUpTimes: [
                    {required: true,message: this.$t('请输入正确的高频上报次数!')}
                ]
            }
        },
        taskRules () {
            return {
                taskName:[{ required: true, message: this.$t('请输入任务名称')}], //订单编号
            }
        },
    },
    methods: {
        moment,
        filterAuth() {
            let permissionList = [];
            let authList = JSON.parse(sessionStorage.getItem(USER_AUTH) || "[]");
            console.log(authList)
            for (let auth of authList) {
                if(auth.type != '2') {
                    permissionList.push(auth);
                }
            }
            if (permissionList === null || permissionList === "" || permissionList === undefined||permissionList.length<=0) {
                this.commandList = []
                return;
            }
            let permissions = [];
            for (let item of permissionList) {
                if(item.type != '2'){
                //update--begin--autor:wangshuai-----date:20200729------for：按钮权限，授权标识的提示信息是多个用逗号分隔逻辑处理 gitee#I1OUGU-------
                if(item.action){
                    if(item.action.includes(",")){
                    let split = item.action.split(",")
                    for (let i = 0; i <split.length ; i++) {
                        if(!split[i] ||split[i].length==0){
                            continue;
                        }
                        permissions.push(split[i]);
                    }
                    }else{
                    permissions.push(item.action);
                    }
                }
                //update--end--autor:wangshuai-----date:20200729------for：按钮权限，授权标识的提示信息是多个用逗号分隔逻辑处理 gitee#I1OUGU------
                }
            }
            console.log(permissions)
            let cmdList = []
            for(let item of this.originalCommandList) {
                if(permissions.includes('newcommand'+item.key)) {
                    cmdList.push(item)
                }
            }
            this.commandList = cmdList
        },
        edit(record) {
            this.filterAuth();
            this.visible = true;
            this.model = Object.assign({}, record);
            this.taskModel = this.$options.data.call(this).taskModel
            //this.formModel.meterId = record.meterId;
            console.log("啦啦啦",this.model.batchType)
            if(this.model.batchType === 1) {
              this.queryAreaTree();
            }
        },
        handleSubmit() {
            const { fileList } = this;
            if(this.model.batchType===1&&this.checkedAreaKeys.length===0) {
                // 按区域批量下发命令
                this.$message.error(this.$t("请先选择区域"))
                return
            }else if(this.model.batchType===2&&(isUndefinedAndNull(this.model.meterIdList)||this.model.meterIdList.length===0)) {
                this.$message.error(this.$t("请先选择表号"))
                return
            }else if(this.model.batchType===3&&fileList.length===0) {
                this.$message.error(this.$t("请先上传excel文件"))
                return
            }
            this.validateTaskAndSubmit()
        },
        validateTaskAndSubmit() {
            this.$refs.taskModal.validate(valid => {
                if(valid) {
                    this.validateCommandAndSubmit()
                }
            })
        },
        validateCommandAndSubmit() {
            if(isUndefinedAndNull(this.commandKey)) {
                this.$message.error(this.$t("请先选择命令"))
                return
            }
            this.$refs.formModel.validate(valid => {
                if (valid) {
                    this.confirmLoading = true
                    this.sendCommand(this.setCommandParams())
                }
            })
        },
        setCommandParams() {
            let params =  {}
            //params.meterId = '867900043325003'
            //params.meterId = this.formModel.meterId
            params.tag = this.commandKey
            if(this.commandKey === 3) {
                // 查询历史日结信息
                params.startDate = this.formModel.startDate.format('YYMMDD')
                params.recordNum = this.formModel.recordNum
            }else if([4,5,6].includes(this.commandKey)) {
                // 查询信息
                params.startNo = this.formModel.startNo
                params.recordNum = this.formModel.recordNum
            }else if(this.commandKey == 7) {
                // 开阀(强制)
                params.tag = 0
                params['20'] = 1
            }else if(this.commandKey == 8) {
                // 关阀(强制)
                params.tag = 0
                params['20'] = 0
            }else if(this.commandKey == 9) {
                // 取消阀控
                params.tag = 0
                params['20'] = 2
            }else if (this.commandKey == 11) {
                // 关阀
                params.tag = 0
                params['20'] = 3
            } else if (this.commandKey == 12) {
                params.tag = 0
                params['20'] = 4
            } else if (this.commandKey === 10) {
                // 查询实时数据
                params.tag = 7
            }else if(this.commandKey == 13) {
                // 加密参数
                params.tag = 57
                if(!isUndefinedAndNull(this.formModel.enKey)) {
                    params['1'] = this.formModel.enKey
                }
            }else if(this.commandKey == 14) {
                // 加密参数
                params.tag = 58
                if(!isUndefinedAndNull(this.formModel.rootKey)) {
                    params['2'] = this.formModel.rootKey
                }
            } else if(this.commandKey === 0) {
                // 终端参数设置
                if(this.setCommandParamsKey.includes(0)) {
                    // 设置过流信息
                    if(!isUndefined(this.formModel.overflowAlarmTop)) {
                        params['0'] = this.formModel.overflowAlarmTop
                    }
                    if(!isUndefined(this.formModel.overflowContinueTime)) {
                        params['1'] = this.formModel.overflowContinueTime
                    }
                    if(!isUndefined(this.formModel.reverseOverflowAlarmTop)) {
                        params['2'] = this.formModel.reverseOverflowAlarmTop
                    }
                    if(!isUndefined(this.formModel.reverseOverflowContinueTime)) {
                        params['3'] = this.formModel.reverseOverflowContinueTime
                    }
                }
                if(this.setCommandParamsKey.includes(1)) {
                    // 设置网络参数
                    if(!isUndefinedAndNull(this.formModel.netIp)&&!isUndefinedAndNull(this.formModel.netPort)) {
                        params['5'] = this.formModel.netIp+','+this.formModel.netPort
                    }
                }
                if(this.setCommandParamsKey.includes(2)) {
                    // 即时告警
                    if(!isUndefined(this.formModel.currentAlarmId)) {
                        params['4'] = this.formModel.currentAlarmId
                    }
                }
                 if(this.setCommandParamsKey.includes(3)) {
                    // apn
                    if(!isUndefined(this.formModel.currentAlarmId)) {
                        params['6'] = this.formModel.apn
                    }
                }
                if(this.setCommandParamsKey.includes(4)) {
                    if(!isUndefinedAndNull(this.formModel.checkTimeWay)) {
                        params['59'] = this.formModel.checkTimeWay
                    }
                    // 校时
                    if(!isUndefinedAndNull(this.formModel.checkTime)) {
                        params['31'] = this.formModel.checkTime.format('YYYYMMDDHHmmss')
                    }
                }
                if(this.setCommandParamsKey.includes(5)) {
                    // 故障清除位
                    if(!isUndefined(this.formModel.cleanFault)) {
                        params['27'] = this.formModel.cleanFault
                    }
                }
                if(this.setCommandParamsKey.includes(6)) {
                    // 设置表底数和脉冲系数
                    if(!isUndefined(this.formModel.firstValue)) {
                        params['28'] = (this.formModel.firstValue*1000).toFixed(0)
                    }
                    if(!isUndefinedAndNull(this.formModel.wareParam)) {
                        params['29'] = this.formModel.wareParam
                    }
                }
                if(this.setCommandParamsKey.includes(7)) {
                    // 写表号
                    if(!isUndefined(this.formModel.newMeterId)) {
                        params['30'] = this.formModel.newMeterId.substr(0,4)+','+this.formModel.newMeterId.substr(-10)
                    }
                }
                if(this.setCommandParamsKey.includes(8)) {
                    // 开关阀
                    if(!isUndefined(this.formModel.fkStatus)) {
                        params['20'] = this.formModel.fkStatus
                    }
                }
                if(this.setCommandParamsKey.includes(9)) {
                    // 设置上报参数
                    if(!isUndefinedAndNull(this.formModel.spreadStartTime)&&!isUndefinedAndNull(this.formModel.spreadEndTime)&&!isUndefinedAndNull(this.formModel.spreadTime)) {
                        let spreadStartTime = this.formModel.spreadStartTime.format('HHmm')
                        let spreadEndTime = this.formModel.spreadEndTime.format('HHmm')
                        let spreadStartTimeDay = '01'
                        let spreadEndTimeDay = '01'
                        if(!isUndefinedAndNull(this.formModel.spreadStartTimeDay)) {
                            spreadStartTimeDay = this.formModel.spreadStartTimeDay.toString().padStart(2,'0')
                        }
                        if(!isUndefinedAndNull(this.formModel.spreadStartTimeDay)) {
                            spreadEndTimeDay = this.formModel.spreadEndTimeDay.toString().padStart(2,'0')
                        }
                        params['7'] = spreadStartTimeDay+spreadStartTime+','+spreadEndTimeDay+spreadEndTime+','+this.formModel.spreadTime
                    }
                    if(!isUndefined(this.formModel.upRate)) {
                        params['8'] = +this.formModel.upRateUnit+','+(('00'+this.formModel.upRate).substr(-2))
                    }
                    if(!isUndefined(this.formModel.reportResetTimes)) {
                        params['9'] = this.formModel.reportResetTimes
                    }
                    if(!isUndefined(this.formModel.reportResetInterval)) {
                        params['10'] = this.formModel.reportResetInterval
                    }
                    if(!isUndefined(this.formModel.reportConcatFailTimes)) {
                        params['11'] = this.formModel.reportConcatFailTimes
                    }
                    if(!isUndefined(this.formModel.reportActiveTimes)) {
                        params['12'] = this.formModel.reportActiveTimes
                    }
                    // 高频上报
                    if(this.highUpStatus == 1) {
                        // 开启
                        params['64'] = this.formModel.highUpRateUnit+','+this.formModel.highUpRate+','+this.formModel.highUpTimes
                    }else if(this.highUpStatus == 2) {
                        // 关闭
                        params['64'] = '20,1,0'
                    }
                }
                if(this.setCommandParamsKey.includes(10)) {
                    // 电压告警阈值
                    if(!isUndefinedAndNull(this.formModel.batteryValue1)&&!isUndefinedAndNull(this.formModel.batteryValue2)) {
                        params['13'] = Number(this.formModel.batteryValue1)*100+','+ Number(this.formModel.batteryValue2)*100
                    }
                }
                if(this.setCommandParamsKey.includes(11)) {
                    console.log(this.formModel.collectStartTime)
                    // 密集采样时间
                    if(!this.isStartCollect) {
                        params['15'] = 255// 不启用密集采样
                    }else{
                        if(!isUndefinedAndNull(this.formModel.collectStartTime)&&!isUndefinedAndNull(this.formModel.collectEndTime)) {
                            params['14'] = this.formModel.collectStartTime.format('HHmmss')+','+ this.formModel.collectEndTime.format('HHmmss')+','+this.formModel.collectTime
                        }
                        if(!isUndefinedAndNull(this.formModel.collectDay)&&this.isStartCollect) {
                            params['15'] = this.formModel.collectDay
                        }
                        if(!isUndefined(this.formModel.collectDay)) {
                            params['16'] = this.formModel.collectModel
                        }
                    }
                }
                if(this.setCommandParamsKey.includes(12)) {
                    // 间隔流量参数
                    if(!this.isStartReportRate) {
                        params['17'] = 255
                    }else{
                        if(!isUndefinedAndNull(this.formModel.reportRateInterval)) {
                            params['17'] = this.formModel.reportRateInterval
                        }
                        if(!isUndefined(this.formModel.rateIntervalModel)) {
                            params['18'] = this.formModel.rateIntervalModel
                        }
                    }
                }
                if(this.setCommandParamsKey.includes(13)) {
                    // 阀门参数配置
                    if(!isUndefined(this.formModel.fkStatus)) {
                        params['62'] = this.formModel.fkStatus
                    }
                    if(!isUndefined(this.formModel.hasFksatus)) {
                        params['19'] = this.formModel.hasFksatus
                        if(this.formModel.hasFksatus == '00') {
                            params['62'] = '00'
                        }
                        if(isUndefinedAndNull(this.formModel.valveCtrlTimeOut)) {
                            params['21'] = this.formModel.valveCtrlTimeOut
                        }
                    }
                    
                }
                if(this.setCommandParamsKey.includes(14)) {
                    // 故障参数配置
                    if(!isUndefinedAndNull(this.formModel.elecTime)&&this.isStartElecCloseFk) {
                        params['22'] = this.formModel.elecTime
                    }else if(!this.isStartElecCloseFk) {
                        params['22'] = 65535
                    }
                    if(!isUndefined(this.formModel.workGrTime)) {
                        params['23'] = this.formModel.workGrTime
                    }
                    if(!isUndefinedAndNull(this.formModel.workGfTime)) {
                        params['24'] = this.formModel.workGfTime
                    }else if(!this.isStartGrCloseFk) {
                        params['24'] = 65535
                    }
                }
                if(this.setCommandParamsKey.includes(15)) {
                    // 加密使能
                    if(!isUndefined(this.formModel.hasEncry)) {
                        params['25'] = this.formModel.hasEncry
                    }
                    if(!isUndefined(this.formModel.sn)) {
                        params['26'] = this.formModel.sn
                    }
                    if(!isUndefined(this.formModel.hasRedEncry)) {
                        params['63'] = this.formModel.hasRedEncry
                    }
                }
                if(this.setCommandParamsKey.includes(16)) {
                    // 上线帧设置
                    if(!isUndefined(this.formModel.directContent)) {
                        params['32'] = this.formModel.directContent
                    }
                }
                if(this.setCommandParamsKey.includes(17)) {
                    // 日结数据指示
                    if(!isUndefinedAndNull(this.formModel.dayRecordNum)&&!isUndefinedAndNull(this.formModel.dayRecordIndex)) {
                        params['33'] = this.formModel.dayRecordNum+','+this.formModel.dayRecordIndex
                    }
                }
                if(this.setCommandParamsKey.includes(18)) {
                    // 表类型切换
                    if(!isUndefined(this.formModel.meterType)) {
                        params['34'] = this.formModel.meterType
                    }
                }
                if(this.setCommandParamsKey.includes(19)) {
                    // 试用量
                    if(!isUndefined(this.formModel.tryNum)) {
                        params['35'] = this.formModel.tryNum
                    }
                }
                if(this.setCommandParamsKey.includes(20)) {
                    // 单价
                    if(!isUndefined(this.formModel.price)) {
                        params['36'] = this.formModel.price
                    }
                }
                if(this.setCommandParamsKey.includes(21)) {
                    // 剩余金额
                    if(!isUndefined(this.formModel.remainyMoney)) {
                        params['37'] = this.formModel.remainyMoney
                    }
                }
                if(this.setCommandParamsKey.includes(22)) {
                    // 工作模式设置
                    if(!isUndefined(this.formModel.workType)) {
                        params['38'] = this.formModel.workType
                    }
                }
                if(this.setCommandParamsKey.includes(23)) {
                    // 补包次数阈值
                    if(!isUndefined(this.formModel.packNum)) {
                        params['39'] = this.formModel.packNum
                    }
                }
                if(this.setCommandParamsKey.includes(24)) {
                    // 压力参数设置
                    if(!isUndefined(this.formModel.pressCollectTime)) {
                        params['40'] = this.formModel.pressCollectTime
                    }
                    if(!isUndefined(this.formModel.pressCollectStartTime)) {
                        params['41'] = this.formModel.pressCollectStartTime.format('YYMMDDHHmm')
                    }
                    if(!isUndefined(this.formModel.pressCollectRecordNum)) {
                        params['42'] = this.formModel.pressCollectRecordNum
                    }
                    if(!isUndefined(this.formModel.pressCollectIndex)) {
                        params['43'] = this.formModel.pressCollectIndex
                    }
                    if(!isUndefined(this.formModel.pressAlarmRate)) {
                        params['44'] = this.formModel.pressAlarmRate
                    }
                    if(!isUndefinedAndNull(this.formModel.pressAlarmTop)) {
                        params['45'] = this.formModel.pressAlarmTop*1000
                    }
                    if(!isUndefinedAndNull(this.formModel.pressAlarmLow)) {
                        params['46'] = this.formModel.pressAlarmLow*1000
                    }
                    /*
                    if(!isUndefined(this.formModel.pressValue)) {
                        params['47'] = this.formModel.pressValue
                    }
                    */
                }
                if(this.setCommandParamsKey.includes(25)) {
                    // 温度参数设置
                    if(!isUndefined(this.formModel.tempCollectTime)) {
                        params['48'] = this.formModel.tempCollectTime
                    }
                    if(!isUndefined(this.formModel.tempCollectStartTime)) {
                        params['49'] = this.formModel.tempCollectStartTime.format('YYMMDDhhmm')
                    }
                    if(!isUndefined(this.formModel.tempCollectRecordNum)) {
                        params['50'] = this.formModel.tempCollectRecordNum
                    }
                    if(!isUndefined(this.formModel.tempCollectIndex)) {
                        params['51'] = this.formModel.tempCollectIndex
                    }
                    if(!isUndefined(this.formModel.tempAlarmRate)) {
                        params['52'] = this.formModel.tempAlarmRate
                    }
                    if(!isUndefinedAndNull(this.formModel.tempAlarmTop)) {
                        params['53'] = this.formModel.tempAlarmTop*100
                    }
                    if(!isUndefinedAndNull(this.formModel.tempAlarmLow)) {
                        params['54'] = this.formModel.tempAlarmLow*100
                    }
                    /*
                    if(!isUndefined(this.formModel.tempValue)) {
                        params['55'] = this.formModel.tempValue
                    }
                    */
                }
                if(this.setCommandParamsKey.includes(26)) {
                    // 报警参数配置
                    if(!isUndefined(this.formModel.freightFk)&&!isNull(this.formModel.freightFk)) {
                        params['58'] = this.formModel.freightFk
                    }
                    if(!isUndefined(this.formModel.freightAlarmMoney)&&!isNull(this.formModel.freightAlarmMoney)) {
                        params['60'] = this.formModel.freightAlarmMoney
                    }
                    if(!isUndefined(this.formModel.freightOverMoney)&&!isNull(this.formModel.freightOverMoney)) {
                        params['61'] = this.formModel.freightOverMoney
                    }
                }
            }
            return params
        },
        // 新协议下发命令
        sendCommand(params) {

            console.log(params);
            params = Object.assign(params, this.taskModel);
            let formData = new FormData();
            formData = paramsToFormData(params);
            if(this.model.batchType===1) {
                // 按区域批量下发命令
                if(this.checkedAreaKeys.length===0) {
                    this.$message.error(this.$t("请先选择区域"))
                    return
                }
                formData.append('areaIdList', [...this.checkedAreaKeys].join(","))
                formData.set('taskName',this.taskModel.taskName+this.$t('(按区域)'))
            }else if(this.model.batchType===2) {
                formData.append('meterIdList',this.model.meterIdList)
                formData.set('taskName',this.taskModel.taskName+this.$t('(按表号)'))
            }else if(this.model.batchType===3) {
                const { fileList } = this;
                if(fileList.length==0) {
                    this.$message.error(this.$t("请先上传excel文件"))
                    return
                }
                fileList.forEach((file) => {
                    formData.append('file', file);
                });
                formData.set('taskName',this.taskModel.taskName+this.$t('(按Excel)'))
            }
            this.handleUpload(formData)
        },
        handleUpload(params) {
            this.confirmLoading = true
            postAction(this.url.sendCommand, params).then((res) => {
                this.confirmLoading = false
                if(res.success){
                    this.$message.success(this.$t("命令添加成功,请至【命令队列--命令任务列表】去查看结果"))
                    this.$emit('ok')
                    this.close()
                }else{
                    this.$message.warning(res.message)
                }
            })
        },
        handleCancel() {
            this.close()
        },
        close () {
            this.$emit('close');
            this.setCommandParamsKey = [];
            this.formModel = this.$options.data.call(this).formModel;
            this.commandKey = this.$options.data.call(this).commandKey;
            this.$refs.formModel.resetFields();
            this.visible = false;
        },
        handleCommandChange(e) {
            console.log(this.formModel.cleanFault)
            this.commandKey = e
            console.log(this.commandKey);
            this.$refs.formModel.resetFields();
            //this.formModel = {meterId: this.model.meterId}
        },
        changeSetParams(e) {
            console.log(e)
            this.setCommandParamsKey = e
        },
        setDefaultCommandParams(key) {
            console.log(key)
            console.log(key.includes(0))
            if(key.includes(0)) {
                delete this.formModel['overflowAlarmTop']
                delete this.formModel['overflowContinueTime']
                delete this.formModel['reverseOverflowAlarmTop']
                delete this.formModel['reverseOverflowContinueTime']
                delete this.formModel['currentAlarmId']
            }
            console.log(this.formModel)
        },
        onSearchArea(){
          this.$refs.areaWindow.add(this.checkedAreaKeys,this.halfCheckedAreaKeys,this.treeData,this.checkedAreaNames,this.userId);
        },
        modalAreaFormOk (formData) {
        this.checkedAreaNames = formData.areaNameList;
        this.checkedAreaNameString = this.checkedAreaNames.join(",");
        this.checkedAreaKeys = formData.checkedKeys;
        this.halfCheckedAreaKeys = formData.halfCheckedKeys;
        
        console.log(this.halfCheckedAreaKeys)
      },
      queryAreaTree(){
        queryAreaTreeList().then((res)=>{
          // 过滤出 leaf node 即可，即选中的
          // Tree组件中checkStrictly默认为false的时候，选中子节点，父节点会自动设置选中或半选中
          // 保存 checkedKeys 以及 halfCheckedKeys 以便于未做任何操作时提交表单数据
          if(res.success){
            this.treeData = res.result;
          }
        })
      },
      convertTreeListToKeyLeafPairs(treeList, keyLeafPair = []) {
        for(const {key, leaf, children} of treeList) {
          keyLeafPair.push({key, leaf})
          if(children && children.length > 0) {
            this.convertTreeListToKeyLeafPairs(children, keyLeafPair)
          }
        }
        return keyLeafPair;
      },
      handleRemove(file) {
        const index = this.fileList.indexOf(file);
        const newFileList = this.fileList.slice();
        newFileList.splice(index, 1);
        this.fileList = newFileList;
      },
     beforeUpload(file) {
        let fileName = file.name;
        let fileType = fileName.substring(fileName.lastIndexOf("."),fileName.length);
        if(fileType!='.xls') {
            this.$message.error(this.$t("只支持.xls格式文件！"))
            return false;
        }else{
            this.fileList = [file];
            return false;
        }
    },
    }
}
</script>
<style scoped>
.ant-form >>> .ant-form-item .ant-input-number{
    width: 100%;
}
.ant-form >>> .ant-input-number-affix .ant-input-number{
    width: calc(100% - 50px);
}
.ant-input-number-suffix{
    display: inline-block;
    width: 50px;
    text-align: left;
    padding-left: 3px;
}
.detail-list >>> .content{
    line-height: normal;
}
.ant-modal-root >>> .ant-modal-cust-warp .ant-modal{
    max-height: 1000px;
}
.form-item-series >>> .series-first .ant-select-selection {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}
.form-item-series >>> .series-last .ant-select-selection {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}
.form-contain{
    max-height: 60vh;
    overflow-y: scroll;
    overflow-x: hidden;
}
.form-contain >>> .ant-divider-inner-text{
    color: rgba(24,144,255,0.85);
    font-size: 16px;
}
</style>